import { createSlice } from "@reduxjs/toolkit";
import { currentWeekPeriod } from "@/utils/date-range";
import { FilterStateDepositBatches } from "./types";

const INITIAL_STATE: FilterStateDepositBatches = {
  filters: {
    ...currentWeekPeriod(),
    pageSize: 20,
    meta: { page: 1 },
  },
};

const filterDepositBatchesSlice = createSlice({
  name: "filterDepositBatches",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = {
        ...currentWeekPeriod(),
        pageSize: 20,
        meta: { page: 1 },
      };
    },
  },
});

export const { setFilter, resetFilters } = filterDepositBatchesSlice.actions;
export default filterDepositBatchesSlice.reducer;
